import { LOCATION_CHANGE } from 'connected-react-router';
import { getQueryString } from '../selectors/uri_selectors';
import { isSearchResult, isMainPage } from '../helpers/urlParts';
import { queryString as queryStringAction } from '../actions/uri_actions';
import {fetchProducts, resetSearch, reset} from '../actions/product';
import { getQueryParams } from '../helpers/urlParts';
import { isCustomerTypeValid } from '../helpers/customer_type_helper';
import { updateCustomerType } from '../actions/customer_type_actions';
import { getConfigValue } from '../reducers/configReducer';
import { CUSTOMER_TYPE_ALLOW } from '../config/const';
import CustomerType  from '../const/customer_type';
import { setCustomerTypeQueryParameter } from '../services/uri';
import { getSelectedCustomerType } from '../selectors/customer_type_selector';

const locationMiddleware = store => next => action => {
  if (action.type === LOCATION_CHANGE) {
    const queryString = action.payload.location.search || '';
    const queryParams = getQueryParams(queryString);
    const customerTypeAllowed = getConfigValue(CUSTOMER_TYPE_ALLOW, store.getState());

    store.dispatch(queryStringAction(queryString));

    if (customerTypeAllowed === CustomerType.ALL) {
      if (queryParams.customerType && isCustomerTypeValid(queryParams.customerType)) {
        store.dispatch(updateCustomerType(queryParams.customerType, false));
      } 
    } else {
      store.dispatch(updateCustomerType(customerTypeAllowed, false));
    }
    setCustomerTypeQueryParameter(getSelectedCustomerType(store.getState()));
  }
  next(action); 
};

export default locationMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/locationMiddleware.js